import { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { NPS_COLOR_TYPE } from 'core/enums/nps-type'

import { Formik, Form, Field } from 'formik'

import { WarningOutlined } from '@material-ui/icons'
import {
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel
} from '@material-ui/core'

import Yup from 'core/validations/index'

import TextField from 'components/Form/Text/TextField'
import Checkbox from 'components/Form/Box/Checkbox'
import Visible from 'components/Form/Box/Visible'

const NPSDefaultFieldsEditor = ({ data, onChange, t }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)
  const [showCommentPromoter, toogleShowCommentPromoter] = useState(
    data?.visiblePromoter
  )
  const [showCommentNeutral, toogleShowCommentNeutral] = useState(
    data?.visibleNeutral
  )
  const [showCommentDetractor, toogleShowCommentDetractor] = useState(
    data?.visibleDetractor
  )

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const fields = {
    Title: data.nps || '',
    CommentTitlePromoter: data.promoter || '',
    CommentTitleNeutral: data.neutral || '',
    CommentTitleDetractor: data.detractor || '',
    CommentRequiredPromoter: data?.requiredPromoter,
    CommentRequiredNeutral: data?.requiredNeutral,
    CommentRequiredDetractor: data?.requiredDetractor,
    CommentVisiblePromoter: data?.visiblePromoter,
    CommentVisibleNeutral: data?.visibleNeutral,
    CommentVisibleDetractor: data?.visibleDetractor,
    NpsScaleStyle: data?.npsScaleStyle || NPS_COLOR_TYPE.default
  }

  const fieldsValidation = Yup.object().shape({
    Title: Yup.string().max(240).required(),
    CommentTitlePromoter: Yup.string().max(240).required(),
    CommentTitleNeutral: Yup.string().max(240).required(),
    CommentTitleDetractor: Yup.string().max(240).required(),
    CommentRequiredPromoter: Yup.bool(),
    CommentRequiredNeutral: Yup.bool(),
    CommentRequiredDetractor: Yup.bool(),
    NpsScaleStyle: Yup.number()
  })

  const dataChanged = (values) => {
    const data = handleDataVisible(values)
    onChange(data)
  }

  const handleDataVisible = (values) => {
    Object.entries(values).forEach((field) => {
      const [key, value] = field

      switch (key) {
        case 'CommentVisibleDetractor':
          toogleShowCommentDetractor(value)
          !value && (values['CommentRequiredDetractor'] = value)
          break
        case 'CommentVisibleNeutral':
          toogleShowCommentNeutral(value)
          !value && (values['CommentRequiredNeutral'] = value)
          break
        case 'CommentVisiblePromoter':
          toogleShowCommentPromoter(value)
          !value && (values['CommentRequiredPromoter'] = value)
          break
        default:
          return
      }
    })

    return values
  }

  return (
    <div className="nps-default-fields-editor">
      <Formik
        initialValues={fields}
        validateOnBlur={false}
        validationSchema={fieldsValidation}
        validate={(values) => dataChanged(values)}
        enableReinitialize={true}
      >
        <Form>
          <div className="form-editor-item">
            <Field
              id="Title"
              name="Title"
              component={TextField}
              placeholder={t('formEditor.nps.npsTitleDesc')}
            />
          </div>

          <div className="form-editor-item">
            <FormLabel component="legend" style={{ marginBottom: 8 }}>
              Tipo de escala NPS
            </FormLabel>
            <Field name="NpsScaleStyle">
              {({ field, form }) => (
                <>
                  <RadioGroup
                    {...field}
                    value={field.value}
                    onChange={(event) => {
                      form.setFieldValue(
                        'NpsScaleStyle',
                        parseInt(event.target.value)
                      )
                    }}
                  >
                    <FormControlLabel
                      value={NPS_COLOR_TYPE.default}
                      control={<Radio color="primary" />}
                      label="Bolinhas"
                    />
                    <FormControlLabel
                      value={NPS_COLOR_TYPE.colorScaleColorful}
                      control={<Radio color="primary" />}
                      label="Escala de cores"
                    />
                    <FormControlLabel
                      value={NPS_COLOR_TYPE.colorGrayScale}
                      control={<Radio color="primary" />}
                      label="Preto e branco"
                    />
                  </RadioGroup>

                  {field.value === NPS_COLOR_TYPE.default ? (
                    <div className="nps-fake-field">
                      {[...Array(11).keys()].map((item) => (
                        <div className="nps-fake-field-item" key={item}>
                          <i className="nps-fake-field-circle"></i>
                          <span className="nps-fake-field-value">{item}</span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <>
                      {!isMobile ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '3px',
                            marginTop: '10px',
                            minWidth: '560px',
                            overflowX: 'auto'
                          }}
                        >
                          {[...Array(11).keys()].map((item) => {
                            const colorfulColors = {
                              0: '#B72224',
                              1: '#D52029',
                              2: '#E95223',
                              3: '#EA6F22',
                              4: '#F6A726',
                              5: '#FDC729',
                              6: '#EBDB0A',
                              7: '#E7E145',
                              8: '#C2D234',
                              9: '#AEC93C',
                              10: '#66B44E'
                            }

                            const grayscaleColors = {
                              0: '#181818',
                              1: '#282828',
                              2: '#383838',
                              3: '#484848',
                              4: '#585858',
                              5: '#686868',
                              6: '#787878',
                              7: '#888888',
                              8: '#989898',
                              9: '#A8A8A8',
                              10: '#B8B8B8'
                            }

                            const colors =
                              field.value === NPS_COLOR_TYPE.colorGrayScale
                                ? grayscaleColors
                                : colorfulColors

                            return (
                              <div
                                key={item}
                                style={{
                                  backgroundColor: colors[item],
                                  color: '#fff',
                                  width: '50px',
                                  height: '50px',
                                  textAlign: 'center',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontFamily:
                                    "'Helvetica', 'Arial', sans-serif",
                                  fontWeight: '600',
                                  fontSize: '24px'
                                }}
                              >
                                {item}
                              </div>
                            )
                          })}
                        </div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '3px',
                            marginTop: '10px'
                          }}
                        >
                          {[...Array(11).keys()].reverse().map((item) => {
                            const colorfulColors = {
                              0: '#B72224',
                              1: '#D52029',
                              2: '#E95223',
                              3: '#EA6F22',
                              4: '#F6A726',
                              5: '#FDC729',
                              6: '#EBDB0A',
                              7: '#E7E145',
                              8: '#C2D234',
                              9: '#AEC93C',
                              10: '#66B44E'
                            }

                            const grayscaleColors = {
                              0: '#181818',
                              1: '#282828',
                              2: '#383838',
                              3: '#484848',
                              4: '#585858',
                              5: '#686868',
                              6: '#787878',
                              7: '#888888',
                              8: '#989898',
                              9: '#A8A8A8',
                              10: '#B8B8B8'
                            }

                            const colors =
                              field.value === NPS_COLOR_TYPE.colorGrayScale
                                ? grayscaleColors
                                : colorfulColors

                            return (
                              <div
                                key={item}
                                style={{
                                  backgroundColor: colors[item],
                                  color: '#fff',
                                  width: '100%',
                                  height: '50px',
                                  textAlign: 'center',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontFamily:
                                    "'Helvetica', 'Arial', sans-serif",
                                  fontWeight: '600',
                                  fontSize: '24px'
                                }}
                              >
                                {item}
                              </div>
                            )
                          })}
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </Field>
          </div>

          <div className="form-editor-item nopadding">
            <div className="form-editor-line form-editor-line-detractor">
              <div class="form-editor-fields">
                <Field
                  id="CommentTitleDetractor"
                  name="CommentTitleDetractor"
                  component={TextField}
                  label={t('formEditor.nps.detractorLabel')}
                  placeholder={t('formEditor.nps.detractorDesc')}
                />
                <div className="form-editor-line-actions">
                  <Field
                    id="CommentRequiredDetractor"
                    name="CommentRequiredDetractor"
                    label={t('formEditor.requiredField')}
                    disabledtooltip={
                      !showCommentDetractor
                        ? t('formEditor.field.requiredInfo')
                        : ''
                    }
                    component={Checkbox}
                    disabled={!showCommentDetractor}
                  />
                  <Field
                    id="CommentVisibleDetractor"
                    name="CommentVisibleDetractor"
                    label="toggle comment detractor visibility"
                    tooltip={t('formEditor.field.visibleInfo')}
                    component={Visible}
                  />
                </div>
              </div>
              {!showCommentDetractor && (
                <div class="form-editor-fields-info">
                  <WarningOutlined style={{ color: '#F7A723' }} />
                  <Typography
                    variant="body2"
                    style={{ marginTop: '3px', color: '#63430e' }}
                  >
                    {t('formEditor.field.visibleAlert')}
                  </Typography>
                </div>
              )}
            </div>

            <div className="form-editor-line form-editor-line-neutral">
              <div class="form-editor-fields">
                <Field
                  id="CommentTitleNeutral"
                  name="CommentTitleNeutral"
                  component={TextField}
                  label={t('formEditor.nps.neutralLabel')}
                  placeholder={t('formEditor.nps.neutralDesc')}
                />
                <div className="form-editor-line-actions">
                  <Field
                    id="CommentRequiredNeutral"
                    name="CommentRequiredNeutral"
                    label={t('formEditor.requiredField')}
                    disabledtooltip={
                      !showCommentNeutral
                        ? t('formEditor.field.requiredInfo')
                        : ''
                    }
                    component={Checkbox}
                    disabled={!showCommentNeutral}
                  />
                  <Field
                    id="CommentVisibleNeutral"
                    name="CommentVisibleNeutral"
                    label="toggle comment neutral visibility"
                    tooltip={t('formEditor.field.visibleInfo')}
                    component={Visible}
                  />
                </div>
              </div>
              {!showCommentNeutral && (
                <div class="form-editor-fields-info">
                  <WarningOutlined style={{ color: '#F7A723' }} />
                  <Typography
                    variant="body2"
                    style={{ marginTop: '3px', color: '#63430e' }}
                  >
                    {t('formEditor.field.visibleAlert')}
                  </Typography>
                </div>
              )}
            </div>

            <div className="form-editor-line form-editor-line-promoter">
              <div class="form-editor-fields">
                <Field
                  id="CommentTitlePromoter"
                  name="CommentTitlePromoter"
                  component={TextField}
                  label={t('formEditor.nps.promoterLabel')}
                  placeholder={t('formEditor.nps.promoterDesc')}
                />
                <div className="form-editor-line-actions">
                  <Field
                    id="CommentRequiredPromoter"
                    name="CommentRequiredPromoter"
                    label={t('formEditor.requiredField')}
                    disabledtooltip={
                      !showCommentPromoter
                        ? t('formEditor.field.requiredInfo')
                        : ''
                    }
                    component={Checkbox}
                    disabled={!showCommentPromoter}
                  />
                  <Field
                    id="CommentVisiblePromoter"
                    name="CommentVisiblePromoter"
                    label="toggle comment promoter visibility"
                    tooltip={t('formEditor.field.visibleInfo')}
                    component={Visible}
                  />
                </div>
              </div>
              {!showCommentPromoter && (
                <div class="form-editor-fields-info">
                  <WarningOutlined style={{ color: '#F7A723' }} />
                  <Typography
                    variant="body2"
                    style={{ marginTop: '3px', color: '#63430e' }}
                  >
                    {t('formEditor.field.visibleAlert')}
                  </Typography>
                </div>
              )}
            </div>
          </div>
        </Form>
      </Formik>
    </div>
  )
}

export default withTranslation()(NPSDefaultFieldsEditor)
